import type {
  InterstateOnChangeEvent,
  SearchInputChangeEventValue
} from "@dealer-center/core-components";
import { Alert, SearchInput } from "@dealer-center/core-components";
import { useState } from "react";

interface PagesUserSearchUiInputProps {
  setName: (name: string) => void;
  nameInput: string;
  setNameInput: (name: string | undefined) => void;
}
export const errorMessageString = "Please Only Enter Numbers or Letters";
export const testId = "ddc-pages-user-search-input";

export const PagesUserSearchUiInput = ({
  nameInput,
  setName,
  setNameInput
}: PagesUserSearchUiInputProps) => {
  const [hasError, setHasError] = useState(false);
  return (
    <>
      <SearchInput
        data-testid={testId}
        inputValue={nameInput}
        placeholder="User ID"
        size={"small"}
        style={"primary"}
        onInputChange={e => {
          if (e.target.value && e.target.value.length > 0 && !isValidInput(e)) {
            setHasError(true);
            return;
          }
          setHasError(false);
          setNameInput(e.target.value);
        }}
        onSearchClick={() => setName(nameInput)}
      />
      {hasError && <Alert type="error">{errorMessageString}</Alert>}
    </>
  );
};

// regex to allow only letters, number, underscore and hyphen
const allowedRegex = /^[a-zA-Z0-9_-]*$/;
export const isValidInput = (
  e: InterstateOnChangeEvent<SearchInputChangeEventValue>
) => e.target.value?.match(allowedRegex) || e.target.value === "";
